export default {
    'found-nothing': 'Niestety nic nie znaleziono :(',
    'placeholder': 'Szukaj...',
    'search': 'Szukaj'
}
